import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

/**
 * Prekvapik__3 (Surprise 3) - Diagonal staircase layout (landscape)
 *
 * Layout: 1 landscape page. Two mirrored diagonal staircases
 * of 5 cells each with fold/cut lines for paper folding.
 *
 * Migrated from C# EduFrame.Img10.Generators.Prekvapik__3
 */
export class Prekvapik__3 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage(true); // landscape
    const margin = PdfUnit.FromMillimeters(5);
    const sz = (PdfSize.A4.width - 2 * margin) / 5;

    const w1 = sz;
    const w2 = PdfSize.A4.height / 2 - 2 * sz;
    const d = (w2 - w1) / 5;

    const cutLines: { p1: PdfPoint; p2: PdfPoint }[] = [];

    for (let i = 0; i < 5; i++) {
      const r1 = new PdfRect(w1 + i * d, margin + i * sz, sz, sz);
      const r2 = new PdfRect(PdfSize.A4.height - r1.x - sz, margin + i * sz, sz, sz);

      if (i < opts.list.length) {
        page.drawLabel(opts.list[i].left, { rect: r1 });
      }
      if (5 + i < opts.list.length) {
        page.drawLabel(opts.list[5 + i].left, { rect: r2 });
      }

      page.drawLine(GUtil.foldPen, r1.topLeft, r1.bottomLeft);
      page.drawLine(
        GUtil.foldPen,
        new PdfPoint(r1.right, r1.top),
        new PdfPoint(r1.right, r1.bottom)
      );
      page.drawLine(GUtil.foldPen, r2.topLeft, r2.bottomLeft);
      page.drawLine(
        GUtil.foldPen,
        new PdfPoint(r2.right, r2.top),
        new PdfPoint(r2.right, r2.bottom)
      );

      if (i + 1 < 5) {
        cutLines.push({
          p1: new PdfPoint(r1.x, r1.bottom),
          p2: new PdfPoint(r1.right + d, r1.bottom),
        });
        cutLines.push({
          p1: new PdfPoint(r2.x - d, r1.bottom),
          p2: new PdfPoint(r2.right, r1.bottom),
        });
      }
    }

    for (const line of cutLines) {
      page.drawLine(GUtil.cutPen, line.p1, line.p2);
    }
  }
}
